import { IconSvgElement } from "@hugeicons/react";
import { Show } from "shared/components";
import { useRentReportingNavCount } from "../use-rent-reporting-nav-count";
import { NavCountPill } from "./NavCountPill";
import { NavLink } from "./NavLink";

export const RentReportingNavLink = ({
  name,
  to,
  Icon
}: {
  name: string;
  to: string;
  Icon: IconSvgElement;
}) => {
  const count = useRentReportingNavCount();

  return (
    <NavLink to={to} HugeIcon={Icon}>
      <div className="flex gap-2 items-center">
        {name}{" "}
        <Show if={count > 0}>
          <NavCountPill count={count} />
        </Show>
      </div>
    </NavLink>
  );
};
